import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Player } from "@lottiefiles/react-lottie-player";
import backgroundAnimation from "../../animations/Animation5.json";
import { useSelector } from "react-redux";
import "./LevelsPage.css";
import { FaCheck, FaLock } from "react-icons/fa";

const LevelPage = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const { state } = useLocation();
  const levels = state?.levels || [];
  const seenList = state?.seenList || [];

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
    if (!state) {
      console.log("state is null");
      navigate("/phase-selection");
    }
  }, [state]);

  const handleLevelClick = (video_url) => {
    navigate("/videos", { state: { video_url: video_url } });
  };

  return (
    <div className="main-page">
      <div className="background-animation">
        <Player autoplay loop src={backgroundAnimation} />
      </div>

      <Card>
        <Card.Body className="level-card">
          {levels?.map((level) => {
            const isSeen = seenList?.some(
              (item) => item.video_id === level?.video_id
            );
            return (
              level?.video_level && (
                <button
                  className="level-button"
                  key={level?.video_id}
                  onClick={() => handleLevelClick(level?.video_url)}
                  disabled={!isSeen && level?.video_level !== "1"}
                >
                  <div style={{ fontSize: "20px", fontWeight: "bold" }}>
                    Level {level.video_level}
                  </div>

                  {isSeen || level?.video_level === "1" ? (
                    <FaCheck style={{ color: "white" }} />
                  ) : (
                    <FaLock style={{ color: "black" }} />
                  )}
                </button>
              )
            );
          })}
        </Card.Body>
      </Card>
    </div>
  );
};

export default LevelPage;
